import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var getDataclbookSlice = createSlice({
    name: "getDataclbook",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getDataclbookSlice_actions = getDataclbookSlice.actions;
export var fetchData = _getDataclbookSlice_actions.fetchData, fetchDataSuccess = _getDataclbookSlice_actions.fetchDataSuccess, fetchDataFailure = _getDataclbookSlice_actions.fetchDataFailure, resetState = _getDataclbookSlice_actions.resetState;
export default getDataclbookSlice.reducer;
